import { Component } from 'react'
import { toast } from 'react-toastify'
import { IClientUID } from '../../../api/clients'
import { isClientMonitored, monitorClient } from '../../../api/0x0001/monitored-client'
import PushRulesPanel from '../../../components/push-rules-panel/push-rules-panel'
import MonitoringCharts from '../../../components/monitoring-charts/monitoring-charts'
import { getString } from '../../../locale'

type Props = {
    clientId: IClientUID
}

type State = {
    working: boolean
    isMonitoring?: boolean
}

class MonitoringTab extends Component<Props, State> {
    state: State = {
        working: false,
        isMonitoring: undefined,
    }

    componentDidMount = async () => {
        await this.loadMonitoringState()
    }

    async loadMonitoringState() {
        try {
            const isMonitoring = (await isClientMonitored(this.props.clientId)).data
            this.setState({ isMonitoring })
        } catch (err) {
            toast.error((err as Error).message)
        }
    }

    async toggleMonitoring() {
        const { isMonitoring } = this.state
        if (isMonitoring === undefined) return
        try {
            this.setState({ working: true })
            await monitorClient(this.props.clientId, !isMonitoring)
            await this.loadMonitoringState()
        } catch (err) {
            toast.error((err as Error).message)
        } finally {
            this.setState({ working: false })
        }
    }

    render() {
        const { isMonitoring, working } = this.state
        return (
            <div>
                <div className="mb-6 bg-white dark:bg-gray-800 rounded-xl shadow-md p-4">
                    <div className="text-lg font-semibold dark:text-white mb-1">{getString('monitoring.title')}</div>
                    <div className="text-sm text-gray-600 dark:text-gray-300 mb-4">{getString('monitoring.description')}</div>
                    <div className="flex flex-wrap gap-2 items-center">
                        <span
                            className={`px-3 py-1 rounded-full text-xs font-semibold ${
                                isMonitoring ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300' : 'bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-200'
                            }`}
                        >
                            {isMonitoring ? getString('monitoring.enabled') : getString('monitoring.disabled')}
                        </span>
                        <button
                            disabled={working || isMonitoring === undefined}
                            onClick={() => this.toggleMonitoring()}
                            className={`px-4 py-2 rounded text-white disabled:opacity-50 ${
                                isMonitoring ? 'bg-red-600 hover:bg-red-700' : 'bg-green-600 hover:bg-green-700'
                            }`}
                        >
                            {isMonitoring ? getString('monitoring.disable') : getString('monitoring.enable')}
                        </button>
                    </div>
                </div>
                {isMonitoring && <MonitoringCharts clientId={this.props.clientId} variant="standard" />}
                <PushRulesPanel clientId={this.props.clientId} monitoringEnabled={!!isMonitoring} />
            </div>
        )
    }
}

export default MonitoringTab
